const agentsSearchPropNameList = [
  'name', 'tags'
  // , 'contractName'
];
export default agentsSearchPropNameList;